import { render, staticRenderFns } from "./Addr.vue?vue&type=template&id=ed5b0106&scoped=true&"
import script from "./Addr.vue?vue&type=script&lang=js&"
export * from "./Addr.vue?vue&type=script&lang=js&"
import style0 from "./Addr.vue?vue&type=style&index=0&id=ed5b0106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5b0106",
  null
  
)

export default component.exports